import React from "react";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKButton from "components/MKButton";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// 9 imagini – curățenie de întreținere (din poze-site)
import intretinere1 from "assets/images/poze-site/8-1-intretinere.webp";
import intretinere2 from "assets/images/poze-site/8-2-intretinere.webp";
import intretinere3 from "assets/images/poze-site/8-3-intretinere.webp";
import intretinere4 from "assets/images/poze-site/8-4-intretinere.webp";
import intretinere5 from "assets/images/poze-site/8-5-intretinere.webp";
import intretinere6 from "assets/images/poze-site/8-6-intretinere.webp";
import intretinere7 from "assets/images/poze-site/8-7-intretinere.webp";
import intretinere8 from "assets/images/poze-site/8-8-intretinere.webp";
import intretinere9 from "assets/images/poze-site/8-9-intretinere.webp";

const images = [
    intretinere1,
    intretinere2,
    intretinere3,
    intretinere4,
    intretinere5,
    intretinere6,
    intretinere7,
    intretinere8,
    intretinere9,
];

function ServicesSection() {
    return (
        <MKBox py={6}>
            <Container>
                <MKTypography variant="h2" textAlign="center" mb={4}>
                    Galerie foto – Servicii de curățenie de întreținere
                </MKTypography>

                <Grid container spacing={3} justifyContent="center">
                    {images.map((img, index) => (
                        <Grid item xs={12} sm={6} md={4} key={index}>
                            <MKBox
                                component="div"
                                sx={{
                                    position: "relative",
                                    width: "100%",
                                    paddingTop: "70%", // raport fix (ex. 7:10). Poți schimba: 56.25% = 16:9, 100% = pătrat
                                    overflow: "hidden",
                                    borderRadius: "lg",
                                    boxShadow: 3,
                                }}
                            >
                                <MKBox
                                    component="img"
                                    src={img}
                                    alt={`Curățenie întreținere ${index + 1}`}
                                    sx={{
                                        position: "absolute",
                                        inset: 0,
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover", // toate imaginile aceeași dimensiune vizuală
                                        transform: index === 1 ? "rotate(-90deg) scale(1.45)" : "none",
                                    }}
                                />
                            </MKBox>
                        </Grid>
                    ))}
                </Grid>

                <MKButton
                    variant="gradient"
                    color="info"
                    size="large"
                    component="a"
                    href="/contact-curatenie"
                    sx={{ mt: 6, mx: "auto", display: "block" }}
                >
                    Solicită o vizită GRATUITĂ pentru ofertă!
                </MKButton>
            </Container>
        </MKBox>
    );
}

export default ServicesSection;
